import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwap = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 640",
		fill: "currentColor",
		...props,
		children: /* @__PURE__ */ _jsx("path", { d: "M60.4 222.2L104 222.2L104 424C104 490.3 157.7 544 224 544C290.3 544 344 490.3 344 424L344 216C344 176.2 376.2 144 416 144C455.8 144 488 176.2 488 216L488 416L444.4 416C428.7 416 416 428.7 416 444.4C416 451.9 419 459.2 424.3 464.5L495 535.2C504.4 544.6 519.6 544.6 528.9 535.2L599.6 464.5C604.9 459.2 607.9 451.9 607.9 444.4C607.9 428.7 595.2 416 579.5 416L535.9 416L535.9 216C535.9 149.7 482.2 96 415.9 96C349.6 96 296 149.7 296 216L296 424C296 463.8 263.8 496 224 496C184.2 496 152 463.8 152 424L152 222.2L195.6 222.2C211.3 222.2 224 209.5 224 193.8C224 186.3 221 179 215.7 173.7L145 103C135.6 93.6 120.4 93.6 111.1 103L40.3 173.7C35 179.1 32 186.3 32 193.8C32 209.5 44.7 222.2 60.4 222.2z" })
	});
};
export default SvgSwap;
